module.exports = __webpack_public_path__ + "static/media/Mask group.691d0af7.png";